// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0855d91f","465":"80fb2ced"}[chunkId] + ".chunk.js";
};